import { EmojiPickerViewState } from '../store/schema/EmojiPickerViewState';
import getPopularEmoji from 'owa-expressions-store/lib/utils/getPopularEmoji';

export default function createEmojiPickerViewState(): EmojiPickerViewState {
    let viewState = <EmojiPickerViewState>{
        emojiResults: getPopularEmoji(),
        queryString: '',
        wordBeforeCursor: '',
        isSuggesting: false,
        isPopupShown: false,
        selectedEmojiIndex: 0,
    };

    return viewState;
}
